import React from 'react';

import queryString from 'query-string';
import { useSelector } from 'react-redux';
import { useLocation } from 'react-router-dom';

import { puckAndPlayerTrackingSelectors } from '../../../../../redux/ducks/puckAndPlayerTracking';
import genericSelectors from '../../../../../redux/genericSelectors';
import { LegendButton } from '../../../../components/buttons';
import Legend from '../../../../components/legend';

import MeasurementToggle from './MeasurementToggle';
import TrackingDataTable from './TrackingDataTable';

import { ActionItemContainer, FullCenteredContainer } from './styles';

const getTeamData = (data, teamId) =>
    data
        // ppt data has numbers as strings, so doing non-strict comparison here
        .filter((d) => d.Entity.EntityTeamId == teamId && d.Entity.Position !== 'G')
        .map((d) => {
            d.Entity.Position = d.Entity.Position !== 'D' ? (d.Entity.Position = 'F') : 'D';
            return d;
        });

const TrackingDataContainer = () => {
    const location = useLocation();
    const { game, pptData, teamData } = useSelector(({ puckAndPlayerTracking }) => puckAndPlayerTracking);

    const visitingTeam = genericSelectors.getTeam(teamData, game.visitingTeamId);
    const homeTeam = genericSelectors.getTeam(teamData, game.homeTeamId);

    const visitingPptData = getTeamData(pptData, visitingTeam.id);
    const homePptData = getTeamData(pptData, homeTeam.id);

    const conversionFactorKey = queryString.parse(location.search).meas || puckAndPlayerTrackingSelectors.IMPERIAL_KEY;
    const speedConversionFactor = puckAndPlayerTrackingSelectors.getSpeedConversionFactorForKey(conversionFactorKey);
    const distanceConversionFactor =
        puckAndPlayerTrackingSelectors.getDistanceConversationFactorForKey(conversionFactorKey);
    const totalDistanceConversionFactor =
        puckAndPlayerTrackingSelectors.getTotalDistanceConversionFactorForKey(conversionFactorKey);

    return (
        <>
            <FullCenteredContainer>
                <ActionItemContainer>
                    <MeasurementToggle conversionFactorKey={conversionFactorKey} />
                    <LegendButton />
                </ActionItemContainer>
            </FullCenteredContainer>
            <div className="tracking-data-container">
                <TrackingDataTable
                    pptData={visitingPptData}
                    team={visitingTeam}
                    game={game}
                    speedConversionFactor={speedConversionFactor}
                    distanceConversionFactor={distanceConversionFactor}
                    totalDistanceConversionFactor={totalDistanceConversionFactor}
                    conversionFactorKey={conversionFactorKey}
                />
                <TrackingDataTable
                    pptData={homePptData}
                    team={homeTeam}
                    game={game}
                    speedConversionFactor={speedConversionFactor}
                    distanceConversionFactor={distanceConversionFactor}
                    totalDistanceConversionFactor={totalDistanceConversionFactor}
                    conversionFactorKey={conversionFactorKey}
                />
            </div>
            <Legend />
        </>
    );
};

export default TrackingDataContainer;
